exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2wF0V{position:absolute;z-index:1000;width:330px;min-height:100px}._3q-Sr{position:absolute;width:12px;height:12px;background:#fff;transform:rotate(45deg)}.cDV2N{z-index:1;box-shadow:0 2px 5px 0 rgba(0,0,0,.21)}.vPjC2{z-index:3}.PCBv0{position:relative;z-index:2;min-height:100px;padding:13px 10px 18px;border-radius:6px;background:#fff;box-shadow:0 3px 11px 0 rgba(0,0,0,.21)}.PCBv0._1qjwE{padding:0 0 24px;overflow:hidden}.PCBv0>section{height:100%;border-radius:6px;overflow:auto}._2sblF>._3q-Sr{display:none}._35qWm>._3q-Sr{top:-4px;left:calc(50% - 6px)}._13Rb7>._3q-Sr{right:-4px;top:calc(50% - 6px)}._3Gk2x>._3q-Sr{bottom:-4px;left:calc(50% - 6px)}.gHT5L>._3q-Sr{left:-4px;top:calc(50% - 6px)}._1XiX2._35qWm>._3q-Sr{left:calc(100% - 37px)}._1XiX2._13Rb7>._3q-Sr{top:calc(100% - 37px)}._1XiX2._3Gk2x>._3q-Sr{left:calc(100% - 37px)}._1XiX2.gHT5L>._3q-Sr{top:calc(100% - 37px)}._3CsWE._35qWm>._3q-Sr{left:25px}._3CsWE._13Rb7>._3q-Sr{top:25px}._3CsWE._3Gk2x>._3q-Sr{left:25px}._3CsWE.gHT5L>._3q-Sr{top:25px}.uigmj.gHT5L>._3q-Sr{background:#fcbc40}.uigmj ._3A2i6{position:absolute;z-index:4;top:0;left:0;bottom:0}.uigmj ._1tCOf{width:5px;border-top-left-radius:6px;border-bottom-left-radius:6px;background:#fcbc40}.uigmj .l4ucY{left:5px;width:5px;background:#fff}._2IuVK.gHT5L>._3q-Sr{background:#aa4dc8}._2IuVK ._3A2i6{position:absolute;z-index:4;top:0;left:0;bottom:0}._2IuVK .m9Mll{width:5px;border-top-left-radius:6px;border-bottom-left-radius:6px;background:#aa4dc8}._2IuVK .l4ucY{left:5px;width:5px;background:#fff}.JqItD{height:100%}", ""]);

// exports
exports.locals = {
	"content": "_2wF0V",
	"triangle": "_3q-Sr",
	"before": "cDV2N",
	"after": "vPjC2",
	"inner": "PCBv0",
	"calendar-popout-inner": "_1qjwE",
	"calendarPopoutInner": "_1qjwE",
	"triangle-none": "_2sblF",
	"triangleNone": "_2sblF",
	"triangle-top": "_35qWm",
	"triangleTop": "_35qWm",
	"triangle-right": "_13Rb7",
	"triangleRight": "_13Rb7",
	"triangle-bottom": "_3Gk2x",
	"triangleBottom": "_3Gk2x",
	"triangle-left": "gHT5L",
	"triangleLeft": "gHT5L",
	"triangle-end": "_1XiX2",
	"triangleEnd": "_1XiX2",
	"triangle-start": "_3CsWE",
	"triangleStart": "_3CsWE",
	"yellow-stripe": "uigmj",
	"yellowStripe": "uigmj",
	"stripe": "_3A2i6",
	"stripe-yellow": "_1tCOf",
	"stripeYellow": "_1tCOf",
	"stripe-white": "l4ucY",
	"stripeWhite": "l4ucY",
	"purple-stripe": "_2IuVK",
	"purpleStripe": "_2IuVK",
	"stripe-purple": "m9Mll",
	"stripePurple": "m9Mll",
	"tooltip-content": "JqItD",
	"tooltipContent": "JqItD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/popout/popout.styl
// module id = 577
// module chunks = app-settings/app-settings dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page